import { render, staticRenderFns } from "./datecontrol.vue?vue&type=template&id=830cc0d4&scoped=true&"
import script from "./datecontrol.vue?vue&type=script&lang=js&"
export * from "./datecontrol.vue?vue&type=script&lang=js&"
import style0 from "./datecontrol.vue?vue&type=style&index=0&id=830cc0d4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "830cc0d4",
  null
  
)

export default component.exports